export const liveConfig = {
    baseUrl: 'https://godelcheckout.live.sofology.co.uk',
    hybrisBaseUrl: 'https://api.g.sofology.co.uk/swkcommercewebservices',
    hybrisProxyBaseUrl: 'https://salesorderprocessing.sofology.co.uk',
    accountBaseUrl: 'https://myaccount.sofology.co.uk',
    forgotPasswordBaseUrl: 'https://myaccount.live.sofology.co.uk',
    donationBaseUrl: 'https://donations.sofology.co.uk',
    fortAwesomeKitUrl: 'https://use.fortawesome.com/61a9ad22.js',
    custexBaseUrl: 'https://custex.sofology.co.uk',
    logisticsUrl: 'https://logistics.sofology.co.uk',
    reservationUrl: 'https://inventory.sofology.co.uk/reservations',
    paymentUrl: 'https://api.sofology.co.uk/api/payments',
    ifcConfigUrl: 'https://api.sofology.co.uk/api',
    webSiteBaseUrl: 'https://www.sofology.co.uk',
    paypal: {
        env: 'production',
        client: {
            sandbox: 'AbdzWd3vpYMFTnAKFbZtcFnsOiKrivYlFazcm6gL_rkpylkZGjK2UytYCf0EwwrgtGGT952L7XOLOL0l',
            production: 'AdWII6CQL0_7ALJl7KnyS4nBjFdpuo--PCmqJLgpdEaDzKkl26WeCZI52yD5flgKfsfkch1YDuYxMGxZ'
        }
    },
    adyen: {
        clientKey: 'live_HWHVQ36VO5E67GR3L2I2WQBBY4MIAM4S',
        environment: 'live',
        isAnalyticEnabled: false
    },
    gtmAffiliation: 'PROD',
    olapicKey: '06d3f7e5b01bed8f98b0e1222f500fd81387414fbf9433133f5f8ef89620455f',
    enableErrorLogging: true,
    logsBaseUrl: 'https://salesorderprocessing.sofology.co.uk/api/log',
    rabbitBaseUrl: 'https://checkout.live.sofology.co.uk/api/rabbit/Basket'
};